import style from '../../styles/Weather/weather_index'

const Title = ({ title }) => {
  return (
    <div className='title-wrapper'>
      <span className='title'>{title}</span>
      <style jsx>{style}</style>
    </div>
  )
}

export default Title
